import { Service } from '@piwikpro/platform';

@Service()
export class NotFoundError extends Error {
  name = 'NotFoundError';

  errors = {};
}
